<form [formGroup]="formGroup">
  @for (row of fieldIDs; track $index) {
    @let last = $last;

    <div class="row g-3 mb-3">
      @for (id of row; track id) {
        <div class="col-12" [ngClass]="last && $first ? 'col-md-12' : 'col-md-6'">
          <div class="form-floating">
            <input
              [attr.type]="id.includes('zipCode') ? 'number' : 'text'"
              class="form-control"
              [ngClass]="{
                'is-valid': getIsValid(id),
                'is-invalid': getIsInvalid(id),
              }"
              [id]="id"
              [formControlName]="id"
              [maxlength]="id.includes('zipCode') ? 4 : null"
              [ngbTypeahead]="isSearchableField(id) ? search : null"
              [inputFormatter]="isSearchableField(id) ? formatter : null"
              [resultFormatter]="isSearchableField(id) ? resultFormatter : null"
              [resultTemplate]="isSearchableField(id) ? resultPreview : null"
              [readonly]="id === 'location'"
              (input)="setContext(id)"
              (selectItem)="onSelectItem($event)"
            />
            <label [for]="id">
              {{ getLabelKey(id) | translate }}
              @if (id.toLowerCase().includes('door') && !isControlEnabled('door')) {
                {{ 'address-input.inputLabel.optional' | translate }}
              }
            </label>
          </div>
        </div>
      }
    </div>
  }
</form>

<ng-template #resultPreview let-result="result" let-term="term">
  <i class="fas fa-map-marker-alt mr-2"></i>
  <ngb-highlight [result]="resultFormatter(result)" [term]="term" />
</ng-template>
